import { render, staticRenderFns } from "./Create-Job.vue?vue&type=template&id=d0134bd6&scoped=true"
import script from "./Create-Job.vue?vue&type=script&lang=js"
export * from "./Create-Job.vue?vue&type=script&lang=js"
import style0 from "./Create-Job.vue?vue&type=style&index=0&id=d0134bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0134bd6",
  null
  
)

export default component.exports